import React, { Component } from "react";
import { connect } from "react-redux";
import { showError, showSuccess } from "ReduxErrorBar";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { deleteSavedItems } from "../../actions";
import GrapesmodalContent from "./grapesmodal";
import LocaleStrings from "Languages";

class TablebodyItem extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, id: 0, section: "" };
  }

  // openModals = (pageid) => this.setState({ isOpen: true, id: pageid});
  openModals = (section) => {
    // this.setState({ isOpen: true, id: pageid });
    this.setState({ isOpen: true, section: section, id: this.props.values.id });
    // let section = response.result.resource[0].section;
  };
  closeModals = () => this.setState({ isOpen: false });

  deleteNewsCallback(values) {
    confirmAlert({
      title: "Delete",
      message: "This will permanently delete the Page. Continue?",
      confirmLabel: "OK",
      cancelLabel: "CANCEL",
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            var id = this.props.values.id;
            this.props.deleteSavedItems(this.props.session, id, (resource) => {
              if (resource.error) {
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.props.showSuccess("Deleted successfully");
              }
            });
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  // editNewsCallback() {}
  viewSite = (e) => {
    let siteURL = "http://staging.teks.co.in/udayan/preview/index";
    // "https://" + siteDetails.resource[0].website_subdomain + ".eventify.io";
    window.open(siteURL, "_blank");
  };

  render() {
    var { values } = this.props;

    return (
      <tr>
        {/*<td>{speaker.speakerid}</td>*/}
        <td>
          <div className="row">
            <div className="col-md-12 col-lg-12 d-flex">
              <div>
                {values.pagetitle.length > 80
                  ? values.pagetitle.substring(0, 80) + "..."
                  : values.pagetitle}
              </div>
              {/* course */}
            </div>
          </div>
        </td>

        <td>
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <div>
                {values.pageurl.length > 80
                  ? values.pageurl.substring(0, 80) + "..."
                  : values.pageurl}
              </div>
              {/* /courses */}
            </div>
          </div>
        </td>

        <td>
          <label className="poll-switch" style={{ margin: 0 }}>
            <input type="checkbox" />
            <span className="poll-slider poll-round"></span>
          </label>
        </td>
        <td>
          <div className="action-button-area" style={{ display: "flex" }}>
            <div className="action-button">
              <button
                className="btn btn-custom-table-white"
                // onClick={() => this.openModals("newpagepreview")}
                onClick={(e) => this.viewSite()}
              >
                Preview Website
              </button>
            </div>
            {/* <div className="action-button"><button className="btn btn-custom-table-white"  onClick={this.openModals}>View & Edit</button> */}
            <div className="action-button">
              <button
                className="btn btn-custom-table-white"
                onClick={() => this.openModals("newpage")}
              >
                Edit
              </button>
              {this.state.isOpen ? (
                <GrapesmodalContent
                  pageid={this.state.id}
                  section={this.state.section}
                  isOpen={this.state.isOpen}
                  onClose={this.closeModals}
                />
              ) : (
                ""
              )}
            </div>
            <div className="action-button">
              <button
                className="i-custom-table-delete"
                onClick={this.deleteNewsCallback.bind(this)}
              >
                <img
                  className="i-custom-table"
                  src="../../style/images/custom-icons/shape-1317-copy-3.svg"
                />
              </button>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    titleUrl: state.titleUrl,
    siteDetails: state.siteDetails,
  };
}

export default connect(mapStateToProps, {
  deleteSavedItems,
  showError,
  showSuccess,
})(TablebodyItem);
